module.exports = __webpack_public_path__ + "img/SZ.d23666d0.svg";